import { sameAddress } from '@safe-global/utils/utils/addresses'

/**
 * Wallets allowed to execute Safe transactions from this UI.
 *
 * Everyone else can still sign; the Execute / Bulk execute buttons are greyed out for them, because in
 * practice only the multiSigExecutor (0x45E8d58AF4946d18C90529e9B48F19ce74cbb809) finalises transactions,
 * and it normally does so via an endpoint rather than this UI.
 *
 * TO ADD AN ADDRESS: append it to the array below (any casing, it is compared case-insensitively) and
 * redeploy the frontend. This is the only place the list lives.
 */
export const ALLOWED_EXECUTORS = [
  '0x45E8d58AF4946d18C90529e9B48F19ce74cbb809',
  '0x86135362aAAf5C00E51b003fb00A34c72A88027A',
  '0x96F8A506F96605C7B1d786E68AF18ab92339fD91',
  '0x8C773CAF4adFCBB720404De9D6BB92ab3DFbF7a2',
  '0x8f6D3d9f0Ca1e04a76cf6190C45B918A5b71f8ec',
]

export const NOT_ALLOWED_EXECUTOR_TOOLTIP = 'Please notify the original SXBet Safe owner to finalize this transaction'

export const isAllowedExecutor = (address?: string): boolean =>
  !!address && ALLOWED_EXECUTORS.some((allowed) => sameAddress(allowed, address))
